import Fieldset from "components/form/Fieldset";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import { useFieldValue } from "components/form/input/NestedField";
import SelectInput from "components/form/input/SelectInput";

/**
 * Retorna o valor do campo que possui o tipo de apontamento (Manual / Mecanizado).
 */
export function useTipoApontamento() {
    return useFieldValue("tipo");
}

export default function ApontamentoAmostraParams({ showTipo = true, children, tipoFixedValue }) {
    return (
        <Fieldset label="Parâmetros da Amostra" fullWidth>
            <FormContent>
                {showTipo ? (
                    <FormRow>
                        <SelectInput
                            name="tipo"
                            label="Tipo"
                            options={["Manual", "Mecanizado"]}
                            disabled={tipoFixedValue ? true : false}
                            initialValue={tipoFixedValue}
                            required
                        />
                    </FormRow>
                ) : null}

                {children}
            </FormContent>
        </Fieldset>
    );
}
